/**
 * 编辑页路由
 */
"use strict";
angular.module("imageTextRouterModule", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.state("imagetext", {
        url: "/imagetext?id&type",
        views: {
            "": {
                template: '<div class="view_head" ui-view="header"></div>' +
	                      '<div class="view_body">' +
	                      '<div class="" ui-view="main"></div>' +
	                      '</div>'
            },
            "header@imagetext": {
                templateUrl: 'header/headerDetails_tpl.html',
                controller: 'webHeaderCtrl'
            },
            "main@imagetext": {
                templateUrl: "./main/submissionManage/personalLibrary/imageText/imageText_tpl.html",
                controller: "imageTextCtrl"
            }
        }
    }).state("imagetextdetail", {
        url: "/imagetextdetail?articleId&type",
        views: {
            "": {
                template: '<div class="view_head" ui-view="header"></div>' +
	                      '<div class="view_body">' +
	                      '<div class="" ui-view="main"></div>' +
	                      '</div>'
            },
            "header@imagetextdetail": {
                 templateUrl: 'header/headerDetails_tpl.html',
                controller: 'webHeaderCtrl'
            },
            "main@imagetextdetail": {
                templateUrl: "./main/submissionManage/personalLibrary/imageText/imageTextDetail/imageTextDetail_tpl.html",
                controller: "imageTextDetailCtrl"
            }
        }
    });
}]);